<template>
  <tr>
    <td class="v-middle" style="width: 100%">
      <template v-for="(diagChartCategoryDetail, index) in diagChartCategory.diagChartCategoryDetails">
        <label :key="index" style="margin: 5px;">
          <CheckBoxForSelect class="inline" :id="diagChartCategoryDetail.itemId"
            :value="diagChartCategoryDetail.diagChartCategoryDetailId"
            :checked="diagChartCategoryDetail.diagChartCategoryDetailItem.diagChartCategoryDetailId"
            @check-input="checkDiagChartCategoryDetailId"
            :key="diagChartCategoryDetail.diagChartCategoryDetailId"
            />
          {{ diagChartCategoryDetail.name }}
        </label>
      </template>
    </td>
  </tr>
</template>

<script>
import CheckBoxForSelect from '@/components/parts/form/CheckBoxForSelect.vue';

export default {
  components: {
    CheckBoxForSelect,
  },
  props: {
    itemId: null,
    diagChartCategory: {
      name: '',
      diagChartCategoryDetails: [
        {
          name: '',
          diagChartCategoryDetailId: null,
          diagChartCategoryDetailItem: {
            diagChartCategoryDetailId: null,
            diagChartCategoryDetailItemId: null, 
            itemId: null
          }
        }
      ]
    },
  },
  methods: {
    checkDiagChartCategoryDetailId(params) {
      this.$emit("check-diag-chart-category-detail-id", params);
    }
  }
}

</script>

<style scoped>
.inline {
  display: inline;
}
</style>
